module.exports = "/assets/data/5fd3628d3e59ae492526e438ed7d583e-BD18.data.json";